import { DivIcon } from 'leaflet'
import { renderToStaticMarkup } from 'react-dom/server'
import { MarkerIcon } from './icons/MarkerIcon'
import { MapIconType, MapMarkerProps } from './MapMarker'
import { ThemeColorKeys } from '@evrekadev/evreka-ui-components'

export const getMarkerIcon = (
  id: string,
  icon?: MapIconType,
  size?: [number, number],
  anchor?: [number, number],
  isSelected?: boolean,
  fill?: ThemeColorKeys,
  customFill?: string,
  badge?: MapMarkerProps['badge'],
  dataTestId?: string,
): DivIcon => {
  const actualSize = size ?? [42, 42]
  const actualAnchor = anchor ?? [21, 21]
  return new DivIcon({
    className: 'custom-icon',
    iconSize: actualSize,
    iconAnchor: actualAnchor,
    html: renderToStaticMarkup(
      getIconElement(id, icon, isSelected, fill, customFill, badge, dataTestId),
    ),
  })
}

const getIconElement = (
  id: string,
  icon?: MapIconType,
  isSelected?: boolean,
  fill?: ThemeColorKeys,
  customFill?: string,
  badge?: MapMarkerProps['badge'],
  dataTestId?: string,
) => {
  if (!icon) {
    return (
      <MarkerIcon
        id={id}
        fill={fill}
        customFill={customFill}
        isSelected={isSelected}
        badge={badge}
        data-testid={dataTestId}
      />
    )
  }
  if (icon === 'ad-hoc') {
    return (
      <MarkerIcon id={id} isSelected={isSelected} badge={badge} isAdhoc data-testid={dataTestId} />
    )
  }
  return icon
}
